// extracted by mini-css-extract-plugin
export default {"button":"ConfirmAddress_button__OZy-4","label":"ConfirmAddress_label__8-59s","InfoMessage":"ConfirmAddress_InfoMessage__5ug9H"};